export default __webpack_public_path__ + "static/media/list_main_14_2.9dce80ad.jpg";